module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content exhibitions"
  }, [_c('div', {
    staticClass: "grid"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibition-single',
        params: {
          year: _vm.startYear(_vm.current.main),
          id: _vm.current.main.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.current.main.image,
      "alt": _vm.altText
    }
  }), _c('div', {
    staticClass: "captions-main"
  }, [_c('h2', {
    staticClass: "h-xl italic"
  }, [_vm._v(_vm._s(_vm.title(_vm.current.main)))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.displayDate(_vm.current.main)))])])])])], 1) : _vm._e()]), _vm._l((_vm.current.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [(!_vm.loading) ? _c('div', {
      key: _vm.title(exhibition),
      staticClass: "screen"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.startYear(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-image"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": exhibition.image,
        "alt": exhibition.title
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-xl italic"
    }, [_vm._v(_vm._s(_vm.title(exhibition)))]), _c('h2', {
      staticClass: "h-l"
    }, [_vm._v(_vm._s(_vm.displayDate(exhibition)))])])])])], 1) : _vm._e()])
  })], 2), _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "further-exhibitions"
    }
  }, [_c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "upcoming"
    }
  }, [_vm._v("upcoming")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'upcoming'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.upcomingFeatured,
      "alt": "Upcoming Exhibitions"
    }
  })])])], 1) : _vm._e()]), (_vm.traveling.image) ? _c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "traveling"
    }
  }, [_vm._v("traveling")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'traveling'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.travelingFeatured,
      "alt": "Traveling Exhibitions"
    }
  })])])], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "col-6_xs-12"
  }, [_c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "past"
    }
  }, [_vm._v("past")]), (!_vm.loading) ? _c('div', {
    staticClass: "half-screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibitions-overview',
        params: {
          year: 'past'
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-image"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.pastFeatured,
      "alt": "Past Exhibitions"
    }
  })])])], 1) : _vm._e()])])]) : _vm._e(), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 no-bottom"
  }, [_c('h1', {
    staticClass: "category h-xl"
  }, [_vm._v("exhibitions")]), _c('h2', {
    staticClass: "h-l",
    attrs: {
      "id": "current"
    }
  }, [_vm._v("on view")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f7336f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exhibitions.vue
// module id = 241
// module chunks = 1